export class positions{
    
    latitude: Number;
    longitude: Number;

}